(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const timerSection = document.querySelector(".countdown-timer-section");
    if (!timerSection) return;

    // Fixed reset time → 5:00 PM
    const RESET_HOUR = 17; // 5 PM
    const RESET_MINUTE = 0;

    // Get digit elements (matches your HTML)
    const hours1El = timerSection.querySelector("[data-hours-1]");
    const hours2El = timerSection.querySelector("[data-hours-2]");
    const minutes1El = timerSection.querySelector("[data-minutes-1]");
    const minutes2El = timerSection.querySelector("[data-minutes-2]");
    const seconds1El = timerSection.querySelector("[data-seconds-1]");
    const seconds2El = timerSection.querySelector("[data-seconds-2]");

    if (
      !hours1El ||
      !hours2El ||
      !minutes1El ||
      !minutes2El ||
      !seconds1El ||
      !seconds2El
    ) {
      console.error("Countdown digits not found");
      return;
    }

    function getNextFivePM() {
      const now = new Date();
      const target = new Date(now);

      target.setHours(RESET_HOUR, RESET_MINUTE, 0, 0);

      // If 5 PM already passed → move to tomorrow
      if (now >= target) {
        target.setDate(target.getDate() + 1);
      }

      return target;
    }

    function updateTimer() {
      const now = new Date();
      const target = getNextFivePM();
      let diff = target.getTime() - now.getTime();

      if (diff < 0) diff = 0;

      const totalSeconds = Math.floor(diff / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const h = String(hours).padStart(2, "0");
      const m = String(minutes).padStart(2, "0");
      const s = String(seconds).padStart(2, "0");

      hours1El.textContent = h[0];
      hours2El.textContent = h[1];
      minutes1El.textContent = m[0];
      minutes2El.textContent = m[1];
      seconds1El.textContent = s[0];
      seconds2El.textContent = s[1];
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  });
})();
